import { useNavigate } from "react-router-dom";
import { useAppStore } from "../stores/useAppStore";

const useMenuNavigation = () => {
  const navigate = useNavigate();
  const { setMenuActiveKey } = useAppStore();

  const navigateTo = (key) => {
    setMenuActiveKey(key);
    navigate(`/${key}`);
  };

  return navigateTo;
};

export default useMenuNavigation;